export default __webpack_public_path__ + "static/media/withGuitars.28f8303b.jpg";